@if (product) {
<div class="flex flex-middle flex-justify-between flex-wrap">
    <breadcrumbs class="block no-scrollbar overflow-auto"></breadcrumbs>
    @if(sku && !isSM){
    <span class="c1 col-1">{{'SKU' | translate}}: {{sku}}</span>
    }
</div>
<div class="flex flex-top flex-justify-between m-t m-t-2-s m-t-2-m">
    <h1 class="h1 h2-s h2-m">{{ product.parent.data?.name || product.data?.name }}</h1>
    @if(!isSM){
    <product-view-wishlist-toggle class="block" style="min-width: 33px;" [productId]="product.id"></product-view-wishlist-toggle>
    }
</div>
@if (product.data?.short_description && !isSM) {
<p class="p1 m-t-2 col-1">{{ product.getAttr('short_description') }}</p>
}
@if(isSM && sku){
<p class="col-1 flex flex-middle m-t-2"><span class="s2 block"
          style="margin-right: 10px;">{{'SKU' | translate}}</span><span class="p2">{{sku}}</span></p>
}
@if (product?.parent) {
<product-reviews-summary class="m-t-2 block"
                         [content]="content"
                         [product]="product"></product-reviews-summary>
}
}